import { useModal } from '@bnetex/ui-kit/modal';
import { EnablingNotificationsModal } from '../ui/enablingNotificationsModal/enablingNotificationsModal';
import { useNotifications } from './useNotifications';
import { useCallback } from 'react';

export const useEnablingNotificationsModal = () => {
    const [ openModal, closeModal ] = useModal(EnablingNotificationsModal);
    const { browser } = useNotifications();

    const openModalWithCondition = useCallback(() => {
        // в текущей реализации closeModal будет закрывать открытую на данный момент модалку
        // а не ту модалку, которую мы передаем в хук useModal.
        // здесь мы закрываем модалку startDemoModal, вызывающую эту функцию.
        // закрываем, если уведы запрещены.
        // toDo: вероятно, стоит показывать какую-то вьюшку, в которой говорим,
        // что уведы запрещены. Уже не оченьь понятно что мы там закрываем. startDemoModal не существует
        if (browser?.permission === 'denied') return closeModal();
        openModal({});
    }, [ browser ]);

    return openModalWithCondition;
};
